import { FC, PropsWithChildren, useMemo, useState } from 'react';

import { QuotationInfoContext } from './QuotationInfoContext';

import { LOADING_SAVED_QUOTATIONS_STATES, QuotationInfo, QuotationStep } from '../../interfaces';
import { LOADING_RENEWAL_QUOTATION_STATES } from '../../interfaces/loading-renewal-quotation-states-enum';

export const QuotationInfoProvider: FC<PropsWithChildren> = ({ children }) => {
  const [allArticleSelected, setAllArticleSelected] = useState<any>();
  const [canShowConfirmIssue, setCanShowConfirmIssue] =
    useState<boolean>(false);
  const [canShowConfirmRenewal, setCanShowConfirmRenewal] =
    useState<boolean>(false);
  const [currentStep, setCurrentStep] = useState<number>(QuotationStep.ONE);
  const [quotationInfo, setQuotationInfo] = useState<QuotationInfo>();
  const [loadingSavedQuotation, setLoadingSavedQuotation] = useState<boolean>(false);
  const [quoatationInfoRequest, setQuoatationInfoRequest] = useState<any>();

  const [savedQuotation, setSavedQuotation] = useState<any>();
  const [quotationToRenewal, setQuotationToRenewal] = useState<any>();

  const [loadingRenewalQuotation, setLoadingRenewalQuotation] = useState<boolean>(false);

  const [loadSaveQuotationState, setLoadSaveQuotationState] = useState<LOADING_SAVED_QUOTATIONS_STATES>();

  const [renewalQuotationState, setRenewalQuotationState] = useState<LOADING_RENEWAL_QUOTATION_STATES>();

  const values = useMemo(
    () => ({
      allArticleSelected,
      canShowConfirmIssue,
      currentStep,
      quotationInfo,
      quoatationInfoRequest,
      setAllArticleSelected,
      setCanShowConfirmIssue,
      setCurrentStep,
      setQuotationInfo,
      setQuoatationInfoRequest,
      loadingSavedQuotation,
      setLoadingSavedQuotation,

      savedQuotation,
      quotationToRenewal,
      setQuotationToRenewal,
      setSavedQuotation,
      loadSaveQuotationState, 
      setLoadSaveQuotationState,
      renewalQuotationState,
      setRenewalQuotationState,
      loadingRenewalQuotation,
      setLoadingRenewalQuotation,
      setCanShowConfirmRenewal,
      canShowConfirmRenewal
    }),
    [
      allArticleSelected,
      canShowConfirmIssue,
      currentStep,
      quotationInfo,
      quoatationInfoRequest,
      setAllArticleSelected,
      setCanShowConfirmIssue,
      setCurrentStep,
      setQuotationInfo,
      setQuoatationInfoRequest,
      loadingSavedQuotation,
      setLoadingSavedQuotation,

      savedQuotation,
      setSavedQuotation,
      quotationToRenewal,
      setQuotationToRenewal,
      loadSaveQuotationState, 
      setLoadSaveQuotationState,
      renewalQuotationState,
      setRenewalQuotationState,
      loadingRenewalQuotation,
      setLoadingRenewalQuotation,
      setCanShowConfirmRenewal,
      canShowConfirmRenewal
    ]
  );

  return (
    <QuotationInfoContext.Provider value={values}>
      {children}
    </QuotationInfoContext.Provider>
  );
};
